module.exports = __webpack_public_path__ + "static/bgmobile-d80021d2b9b4134f2b7c6e00190a1b08.png";